<template>
  <div>
    <apply-step ref="applyStepRef" v-if="!isReadonly" />

    <div class="container">
      <component v-if="currentComponentName" :is="currentComponentName" ref="countryFormRef" :isReadonly="isReadonly" />

      <!-- 保存 -->
      <template v-if="!isReadonly">
        <div class="pt50 pb26 fxRow" v-if="initOk">
          <el-button type="primary" :disabled="saveLoading || nextLoading" @click="lastStep" class="pl20 pr20 fz16 mr16">
            {{ $t("common.button.last") }}
          </el-button>
          <el-button :loading="saveLoading" :disabled="nextLoading" @click="onSubmit" class="pl20 pr20 fz16 mr16">{{ $t("common.button.save") }}</el-button>
          <el-button :loading="nextLoading" :disabled="saveLoading" type="primary" @click="nextStep" class="pl20 pr20 fz16">{{ $t("common.button.next") }}</el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ApplyStep from "@/components/ApplyStep";
import SingaporeForm from "./singapore/index";
import MalaysiaForm from "./malaysia/index";
import pageGuardMixin from "@/mixins/pageGuardMixin";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "EnrollEstablish",
  mixins: [pageGuardMixin],
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ApplyStep,
    SingaporeForm,
    MalaysiaForm,
  },
  data() {
    return {
      initOk: false, // 初始化是否完成
      applyId: null,
      saveLoading: false,
      nextLoading: false,
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["getCountryComponentName"]),
    // 根据当前申请单国家，获取对应的 componentName
    currentComponentName() {
      // 非只读模式下，需确保 vuex 中的申请单详情与当前 url 的 id 匹配，
      // 避免页面初始化时短暂渲染上一个申请单对应的国家组件
      if (!this.isReadonly && this.applymentDetail?.id !== this.applyId) {
        return "";
      }
      return this.getCountryComponentName;
    },
  },
  methods: {
    ...mapActions("applyment", ["fetchApplymentDetail", "saveApplyment"]),

    // 保存接口 - http
    saveHttp(type) {
      return new Promise((resolve, reject) => {
        // 获取参数
        const params = this.$refs.countryFormRef.getParamsData();

        this.saveRequestState = 1;
        const currentStepIndex = this.$refs.applyStepRef.getCurrentStepIndex();
        const finalParams = {
          ...params,
          lastStayPage: type == "next" ? currentStepIndex + 1 : currentStepIndex,
        };

        this.saveApplyment(finalParams)
          .then(res => {
            this.saveRequestState = 2;
            resolve(res);
          })
          .catch(err => {
            this.saveRequestState = 3;
            reject(err);
          });
      });
    },

    // 保存
    async onSubmit() {
      try {
        this.saveLoading = true;
        await this.saveHttp();
        this.$message.success(this.$t("common.success.save"));
      } catch (error) {
        console.error(error);
      } finally {
        this.saveLoading = false;
      }
    },

    // 上一步
    lastStep() {
      this.$refs.applyStepRef.toPreviousStep();
    },

    // 下一步
    async nextStep() {
      try {
        await this.$refs.countryFormRef.dataFormSubmit();
        this.nextLoading = true;
        await this.saveHttp("next");
        this.$refs.applyStepRef.toNextStep();
      } catch (error) {
        console.error(error);
        this.nextLoading = false;
      }
    },

    // 页面初始化
    pageInit() {
      this.fetchApplymentDetail(this.applyId).then(() => {
        // 检查当前页面的申请步骤是否存在(pageGuardMixin中的方法)
        this.checkCurrentPageHasApplyStep();
        // 检查当前页面的申请状态能否进入该页面(pageGuardMixin中的方法)
        this.checkCurrentPageSupportApplymentStatus();
        // 数据初始化处理交由子组件处理
        this.$nextTick(() => {
          const ref = this.$refs.countryFormRef;
          if (!ref || typeof ref.dataInit !== "function") {
            return;
          }
          ref.dataInit();
          this.initOk = true;
        });
      });
    },
  },
  created() {
    if (!this.isReadonly) {
      // 检查url是否携带参数id (pageGuardMixin中的方法)
      this.checkPathQueryHasId();
      // 检查url是否存在参数(id)
      if (this.$route.query.id) {
        this.applyId = this.$route.query.id;
        this.pageInit();
      }
    }
  },
};
</script>
